import React, { useMemo } from 'react'
import MobileCategories from '../MobileCategories/MobileCategories'
import MobileCategoriesOptions from '../MobileCategories/MobileCategoriesOptions'
import useDelayUnmount from 'hooks/useDelayUnmount'
import AccountLinksDropDown from '../../IconActions/User/AccountLinksDropDown'
import AuthLinksDropDown from '../../IconActions/User/AuthLinksDropDown'
import { useHeaderContext } from '../../HeaderContext'
import { useSelector } from 'react-redux'
import { isSessionSet } from 'selectors/user/session'

// The dropdowns are shared with the desktop header, where they are driven by their own
// open/hover state — inside the mobile menu they are always the open one
const MobileAccountLinks = () => <AccountLinksDropDown dropdownIsOpen dropdownIsHovered={false} />
const MobileAuthLinks = () => <AuthLinksDropDown dropdownIsOpen dropdownIsHovered={false} />

const MENU_CONTENT = {
  ['null']: null,
  ['categories']: MobileCategories,
  ['subCategories']: MobileCategoriesOptions,
  ['user']: MobileAccountLinks,
  ['auth']: MobileAuthLinks,
  ['search']: null,
}

const MenuContent = () => {
  const isSessionReady = useSelector(isSessionSet)
  const { mobileHeaderConfig } = useHeaderContext()
  // this is to delay the unmount of the component to be able to see the animation, if you need animation increase the value to 500
  const shouldRenderChild = useDelayUnmount(mobileHeaderConfig.isMobileMenuOpen, 0)

  const ContentComponent = useMemo(
    () => (shouldRenderChild ? MENU_CONTENT[mobileHeaderConfig.mobileMenuContent] : null),
    [shouldRenderChild, mobileHeaderConfig.mobileMenuContent]
  )

  if (!isSessionReady) {
    return null
  }

  return shouldRenderChild && ContentComponent ? <ContentComponent /> : null
}

export default MenuContent
